 
export function spRemoveFromCart(items) {
    if (!Array.isArray(items)) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'sp_remove_from_cart',
        ecommerce: {
            items
        }
    });
}